import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import ComingSoon from './pages/ComingSoon';

import Login      from './pages/Login';
import Dashboard  from './pages/Dashboard';
import Productos  from './pages/Productos';
import Compras    from './pages/Compras';
import Ventas     from './pages/Ventas';
import Facturas   from './pages/Facturas';
import Clientes   from './pages/Clientes';
import Cobranzas  from './pages/Cobranzas';
import Stock      from './pages/Stock';
import Proveedores from './pages/Proveedores';
import Pagos      from './pages/Pagos';
import Cajas      from './pages/Cajas';
import Bancos     from './pages/Bancos';
import Usuarios   from './pages/Usuarios';
import Categorias from './pages/Categorias';
import Parametros from './pages/Parametros';
import Depositos  from './pages/Depositos';
import Ajustes    from './pages/Ajustes';
import Roles      from './pages/Roles';
import Plantillas from './pages/Plantillas';
import Ayuda      from './pages/Ayuda';
import Reportes   from './pages/Reportes';

export default function App() {
  return (
    <GoogleReCaptchaProvider reCaptchaKey="6Lf7r_osAAAAAGcGCUE9Gz0IGiDpOV2zQZx6Fkgv">
    <ThemeProvider>
    <AuthProvider>
      <BrowserRouter>
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 3000,
            style: { borderRadius: '12px', fontSize: '14px' },
          }}
        />
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/dashboard" replace />} />

            {/* Dashboard */}
            <Route path="dashboard" element={<Dashboard />} />

            {/* Ventas */}
            <Route path="ventas" element={<Navigate to="/ventas/facturas" replace />} />
            <Route path="ventas/pos"       element={<Ventas />} />
            <Route path="ventas/facturas"  element={<Facturas />} />
            <Route path="ventas/clientes"  element={<Clientes />} />
            <Route path="ventas/cobranzas" element={<Cobranzas />} />

            {/* Compras */}
            <Route path="compras" element={<Navigate to="/compras/facturas" replace />} />
            <Route path="compras/proveedores" element={<Proveedores />} />
            <Route path="compras/facturas"    element={<Compras />} />
            <Route path="compras/pagos"       element={<Pagos />} />

            {/* Stock */}
            <Route path="stock" element={<Navigate to="/stock/movimientos" replace />} />
            <Route path="stock/productos"   element={<Productos />} />
            <Route path="stock/depositos"   element={<Depositos />} />
            <Route path="stock/movimientos" element={<Stock />} />
            <Route path="stock/ajustes"     element={<Ajustes />} />

            {/* Tesorería */}
            <Route path="tesoreria/cajas"  element={<Cajas />} />
            <Route path="tesoreria/bancos" element={<Bancos />} />

            {/* Reportes */}
            <Route path="reportes" element={<Reportes />} />

            {/* Ayuda */}
            <Route path="ayuda" element={<Ayuda />} />

            {/* Configuración */}
            <Route path="configuracion/usuarios"   element={<Usuarios />} />
            <Route path="configuracion/roles"      element={<Roles />} />
            <Route path="configuracion/plantillas" element={<Plantillas />} />
            <Route path="configuracion/categorias" element={<Categorias />} />
            <Route path="configuracion/parametros" element={<Parametros />} />

            {/* Rutas legacy — redirigen a nuevas rutas */}
            <Route path="productos"   element={<Navigate to="/stock/productos"    replace />} />
            <Route path="proveedores" element={<Navigate to="/compras/proveedores" replace />} />
          </Route>

          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
    </ThemeProvider>
    </GoogleReCaptchaProvider>
  );
}
